import register from '../../../../global/js/registry';
export default register('m-job-offer-area', () => import(/* webpackMode: "lazy" */ './m-job-offer-area.controller'));
